/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleSignInUserDto } from './GoogleSignInUserDto';
import {
    GoogleSignInUserDtoFromJSON,
    GoogleSignInUserDtoFromJSONTyped,
    GoogleSignInUserDtoToJSON,
    GoogleSignInUserDtoToJSONTyped,
} from './GoogleSignInUserDto';

/**
 * 
 * @export
 * @interface GoogleSignInResponseDto
 */
export interface GoogleSignInResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSignInResponseDto
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSignInResponseDto
     */
    requiresOnboarding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSignInResponseDto
     */
    requiresIdentityVerification?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GoogleSignInResponseDto
     */
    onboardingStep?: number;
    /**
     * 
     * @type {GoogleSignInUserDto}
     * @memberof GoogleSignInResponseDto
     */
    user?: GoogleSignInUserDto;
    /**
     * 
     * @type {string}
     * @memberof GoogleSignInResponseDto
     */
    customToken?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSignInResponseDto
     */
    sessionId?: string;
}

/**
 * Check if a given object implements the GoogleSignInResponseDto interface.
 */
export function instanceOfGoogleSignInResponseDto(value: object): value is GoogleSignInResponseDto {
    return true;
}

export function GoogleSignInResponseDtoFromJSON(json: any): GoogleSignInResponseDto {
    return GoogleSignInResponseDtoFromJSONTyped(json, false);
}

export function GoogleSignInResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSignInResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'requiresOnboarding': json['requiresOnboarding'] == null ? undefined : json['requiresOnboarding'],
        'requiresIdentityVerification': json['requiresIdentityVerification'] == null ? undefined : json['requiresIdentityVerification'],
        'onboardingStep': json['onboardingStep'] == null ? undefined : json['onboardingStep'],
        'user': json['user'] == null ? undefined : GoogleSignInUserDtoFromJSON(json['user']),
        'customToken': json['customToken'] == null ? undefined : json['customToken'],
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
    };
}

export function GoogleSignInResponseDtoToJSON(json: any): GoogleSignInResponseDto {
    return GoogleSignInResponseDtoToJSONTyped(json, false);
}

export function GoogleSignInResponseDtoToJSONTyped(value?: GoogleSignInResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'requiresOnboarding': value['requiresOnboarding'],
        'requiresIdentityVerification': value['requiresIdentityVerification'],
        'onboardingStep': value['onboardingStep'],
        'user': GoogleSignInUserDtoToJSON(value['user']),
        'customToken': value['customToken'],
        'sessionId': value['sessionId'],
    };
}

